import gsap from 'gsap';

export default function initOffers() {
    const components = document.querySelectorAll('.offers');

    components.forEach(component => {
        const mediaSlides = component.querySelectorAll('.offers__media img');
        const smallSlides = component.querySelectorAll('.offers__small img');
        const contentSlides = component.querySelectorAll('.offers__content');
        const currentNum = component.querySelector('.pagination .current');
        const prevBtn = component.querySelector('.swiper-button-prev');
        const nextBtn = component.querySelector('.swiper-button-next');

        const totalSlides = contentSlides.length;
        if (totalSlides === 0) return;

        let currentIndex = 0;
        let isAnimating = false;

        const updateSlider = (newIndex) => {
            if (isAnimating || newIndex === currentIndex) return;
            isAnimating = true;

            const direction = newIndex > currentIndex ? 1 : -1;
            const prevIndex = currentIndex;

            // Loop logic
            currentIndex = (newIndex + totalSlides) % totalSlides;

            const tl = gsap.timeline({
                onComplete: () => {
                    isAnimating = false;
                }
            });

            const prevMedia = mediaSlides[prevIndex];
            const nextMedia = mediaSlides[currentIndex];
            const prevSmall = smallSlides[prevIndex];
            const nextSmall = smallSlides[currentIndex];

            // Slide Images
            // Reset next images position
            gsap.set([nextMedia, nextSmall], { xPercent: 100 * direction, visibility: 'visible' });

            tl.to([prevMedia, prevSmall], {
                xPercent: -100 * direction,
                duration: 1,
                ease: "expo.inOut"
            }, 0);

            tl.to([nextMedia, nextSmall], {
                xPercent: 0,
                duration: 1,
                ease: "expo.inOut"
            }, 0);

            tl.set([prevMedia, prevSmall], { visibility: 'hidden' });

            // Content Transition
            const prevContent = contentSlides[prevIndex];
            const nextContent = contentSlides[currentIndex];

            const prevElements = prevContent.querySelectorAll('.subtitle, .offers__content__title, .offers__content__description');
            const nextElements = nextContent.querySelectorAll('.subtitle, .offers__content__title, .offers__content__description');

            tl.to(prevElements, {
                opacity: 0,
                y: -20,
                stagger: 0.05,
                duration: 0.4,
                ease: "power2.in"
            }, 0);

            tl.set(prevContent, { className: "offers__content rich-text" }, 0.4);
            tl.set(nextContent, { className: "offers__content rich-text is-active" }, 0.4);

            tl.fromTo(nextElements, {
                opacity: 0,
                y: 20
            }, {
                opacity: 1,
                y: 0,
                stagger: 0.1,
                duration: 0.8,
                ease: "power3.out"
            }, 0.5);

            // Update Pagination
            if (currentNum) {
                currentNum.innerText = (currentIndex + 1).toString().padStart(2, '0');
            }
        };

        nextBtn?.addEventListener('click', () => {
            updateSlider(currentIndex + 1);
        });

        prevBtn?.addEventListener('click', () => {
            updateSlider(currentIndex - 1);
        });

        // Swipe support
        let touchStartX = 0;
        let touchEndX = 0;

        component.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        component.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            const diffX = touchEndX - touchStartX;
            if (Math.abs(diffX) > 50) {
                if (diffX > 0) {
                    updateSlider(currentIndex - 1);
                } else {
                    updateSlider(currentIndex + 1);
                }
            }
        }, { passive: true });
    });
}
